const Title = () => {
  return (
    <p className='md:text-14-16 lg:text-16-19 lg:pl-5 mr-2.5 w-36'>
      SON HABERLER
    </p>
  );
};
export default Title;
